(function(t, x) {
  function e(a, u) {
    return _(a - 286, u);
  }
  const c = t();
  function o(a, u) {
    return _(u - -882, a);
  }
  for (; []; )
    try {
      if (parseInt(e(632, 603)) / 1 + parseInt(e(621, 604)) / 2 + -parseInt(o(-542, -539)) / 3 * (-parseInt(e(644, 647)) / 4) + -parseInt(o(-543, -513)) / 5 * (-parseInt(e(658, 677)) / 6) + -parseInt(o(-533, -542)) / 7 * (-parseInt(e(671, 691)) / 8) + -parseInt(o(-546, -554)) / 9 + parseInt(e(673, 675)) / 10 * (-parseInt(e(627, 619)) / 11) === x)
        break;
      c.push(c.shift());
    } catch {
      c.push(c.shift());
    }
})(d, -172 * -2057 + 602945 + -616939);
const i = (t, x) => {
  const e = {};
  e[c(-535, -541)] = x;
  function c(a, u) {
    return _(a - -861, u);
  }
  function o(a, u) {
    return _(a - -271, u);
  }
  document["dispatchEv" + o(80, 106)](new CustomEvent(t, e));
}, b = (t, x) => {
  function e(a, u) {
    return _(a - 369, u);
  }
  const c = {};
  c[e(757, 769) + "n"] = x, i(t, c);
};
function n(t, x) {
  return _(t - -251, x);
}
const f = {};
f[n(135, 150)] = n(135, 137), f.ERROR = n(86, 110), f[r(183, 164)] = "WAITING", f.RUNNING = "RUNNING";
const T = f, s = {};
s[n(83, 61) + n(99, 102)] = "candidate_" + n(82, 72);
function r(t, x) {
  return _(t - -166, x);
}
s[n(110, 117) + r(172, 173)] = n(114, 90) + "entering", s[n(79, 82) + r(196, 219)] = r(216, 197) + n(80, 86), s[r(156, 190) + n(93, 65)] = "document_t" + n(74, 68), s[n(85, 109) + r(197, 203)] = r(161, 132) + n(130, 129), s[n(105, 95) + "_TOO_LOW"] = n(116, 110) + r(187, 182), s[n(105, 101) + n(122, 153)] = n(116, 137) + "_too_high", s["HOTSPOTS_P" + n(115, 117)] = r(194, 199) + "resent";
const I = s;
function _(t, x) {
  const e = d();
  return _ = function(c, o) {
    return c = c - (4429 + 552 + 4660 * -1), e[c];
  }, _(t, x);
}
function d() {
  const t = ["e:instruct", "188456QNKQCo", "LOADING", "5652880BaxhNb", "instructio", "CONTINUE_D", "DOCUMENT_T", "DETECTED_D", "anged", "oo_far", "detail", "sharpness_", "3165840esqfHz", "N_CHANGED", "DOCUMENT_N", "ot_present", "ETECTION", "selection", "CANDIDATE_", "411722gPZLwY", "SHARPNESS_", "ERROR", "ENTERING", "CAMERA_PRO", "161BtRpRs", "22yJqNUN", "STATE_CHAN", "3jtNQNo", "OO_FAR", "DOCUMENT_D", "514101xFXeyF", "CONTROL", "ERA", "WAITING", "SELECTION", "ent", "rops-chang", "_too_low", "changed", "-detection", "BRIGHTNESS", "ENT_SIZE", "1015652wymxGb", "etection", "hotspots_p", "DOCUMENT_C", "OT_PRESENT", "TOO_LOW", "VIDEO_ELEM", "document_c", "RESENT", "brightness", "GED", "766150oHbmLT", "switch-cam", "ror", "12piePMl", "_TOO_HIGH", "ANGED", "uto-captur", "continue-d", "e:video-el", "document-a", "-document-", "ROR", "too_low", "document_n", "e:document"];
  return d = function() {
    return t;
  }, d();
}
var E = ((t) => {
  function x(c, o) {
    return n(c - 107, o);
  }
  t[e(921, 933) + x(188, 211)] = x(232, 201) + e(971, 971);
  function e(c, o) {
    return n(o - 863, c);
  }
  return t["SWITCH_CAM" + x(204, 226)] = e(1015, 982) + "era", t["TOGGLE_MIR" + x(236, 229)] = "toggle-mir" + e(981, 983), t;
})(E || {}), N = ((t) => {
  t[e(24, 13) + "PS_CHANGED"] = x(-634, -620) + x(-648, -623) + "e:camera-p" + x(-615, -646) + "ed", t[e(25, 21)] = "document-a" + x(-608, -623) + "e:control", t[x(-700, -675) + "OCUMENT_CH" + x(-619, -624)] = x(-649, -620) + e(58, 49) + "e:detected" + e(62, 53) + x(-655, -644);
  function x(c, o) {
    return r(o - -832, c);
  }
  t[e(3, 19) + e(34, 6)] = "document-auto-captur" + x(-638, -615) + e(43, 29);
  function e(c, o) {
    return n(o - -75, c);
  }
  return t["INSTRUCTIO" + x(-670, -669)] = x(-592, -620) + x(-637, -623) + e(60, 58) + "ion-changed", t[e(8, 16) + x(-624, -630)] = x(-590, -620) + x(-595, -623) + "e:state-ch" + x(-640, -674), t[e(35, 38) + e(3, 31)] = x(-594, -620) + x(-647, -623) + x(-607, -621) + "ement-size", t;
})(N || {});
export {
  T as AppStateValues,
  E as ControlEventInstruction,
  N as DocumentCustomEvent,
  I as DocumentInstructionCodeValues,
  b as dispatchControlEvent
};
